var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlider1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 1600 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000000",
    width: 1600,
    height: 800
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#031a13",
    points: "800 100 0 200 0 800 1600 800 1600 200"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#053526",
    points: "800 200 0 400 0 800 1600 800 1600 400"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#084f39",
    points: "800 300 0 600 0 800 1600 800 1600 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0a694d",
    points: "1600 800 800 400 0 800"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0d8360",
    points: "1280 800 800 500 320 800"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0f9e73",
    points: "533.3 800 1066.7 800 800 600"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#12B886",
    points: "684.1 800 914.3 800 800 700"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider1);
export default __webpack_public_path__ + "static/media/slider1.0790a85197bac4c33b03986ce78cb055.svg";
export { ForwardRef as ReactComponent };